import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Skeleton from 'react-loading-skeleton';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import './Purchase.scss';
import FormHeader from '../FormHeader/FormHeader';
import FormField from '../FormField';
import useCar from '../../utils/hooks/useCar';
import Button from '../Button';
import Recaptcha from '../Recaptcha/Recaptcha';
import bem from '../../utils/bem';
import getCardType from '../../utils/getCardType';
import {
  VISA,
  MASTER_CARD,
  AMEX,
  ENDPOINT_URL,
  SUCURSALES,
} from '../../utils/constants';
import { getUrlParameter, IsOnlyNumbers, postData } from '../../utils/helpers';
import { useUserData } from '../../utils/hooks';
import { useSelector } from 'react-redux';

const RESERVATION_AMOUNT = 1;

const PurchaseProcessing = ({isLoading, car, logoUrl, ...props}) => {
  const history = useHistory();
  const routerLocation = useLocation();
  const action = useMemo(
    () => `${ENDPOINT_URL}/api/cotizador${routerLocation.pathname.replace('/procesando', '')}`,
    [routerLocation.pathname]
  );

  const triggerAction = useCallback(
    (props) => {
    {
      const {
        amount,
        cardExpirationDate,
        checkout_card_card_holder,
        checkout_card_cvv,
        checkout_card_month,
        checkout_card_number,
        checkout_card_year,
        direccion,
        email,
        phone,
        last_name,
        name_client,
      } = props;
      // Initialize the ThreeDSService
      const gateway = window.processor;
      const threeDS = gateway.get3DSecure();
  
      // Create a 3DS Frame
      // This will start out 0px x 0px during fingerprinting.
      // If the customer is prompted to complete a challenge, it will resize automatically.
      
      const options = {
          cardNumber: checkout_card_number,
          cardExpMonth: checkout_card_month,
          cardExpYear: checkout_card_year,
          currency: 'USD',
          amount: `${amount}.00`,
          email,
          phone,
          city: 'San Jose',
          state: 'SJ',
          address1: direccion,
          country: 'CR',
          firstName: name_client,
          lastName: last_name,
          postalCode: '10101'
      };
  
      const threeDSecureInterface  = threeDS.createUI(options);
  
      // Mount the threeDSecureInterface to the DOM
      // This begins the collection of 3DS data.
      threeDSecureInterface.start('body');
  
      // Listen for the threeDSecureInterface to ask the user for a password
      threeDSecureInterface.on('challenge', function(e) {
          console.log('Challenged');
      });
  
      // Listen for the threeDSecureInterface to provide all the needed 3DS data
      threeDSecureInterface.on('complete', function(e) {
        threeDSecureInterface.unmount();
        postData(action, {
          ...props,
          ...options,
          cavv: e.cavv,
          xid: e.xid,
          eci: e.eci,
          cardHolderAuth: e.cardHolderAuth,
          threeDsVersion: e.threeDsVersion,
          directoryServerId: e.directoryServerId,
          cardHolderInfo: e.cardHolderInfo,
        }, 'POST');
      });
  
      // Listen for the threeDSecureInterface to indicate that the customer
      // has failed to authenticate
      threeDSecureInterface.on('failure', function(e) {
        console.log('failure');
        console.log(e);
        threeDSecureInterface.unmount();
        history.push('./?error=Hubo un error al realizar el pago');
      });
  
      // Listen for any errors that might occur.
      gateway.on('error', function (e) {
        threeDSecureInterface.unmount();
        history.push('./?error=Hubo un error al realizar el pago');
      })
    }
  });

  useEffect(() => {
    // if no data has been pushed, lets kick it out
    if (!props.checkout_card_number) {
      history.push('./');
      return;
    }
    triggerAction(props);
  }, [props]);

  return (
    <div className="purchase gradient gradient--full" style={{ '--color': car?.colorCode }}>
      <FormHeader
        isLoading={isLoading}
        car={car}
        logoUrl={logoUrl}
        sectionHeader="ingresá tus datos para comprar tu chuzo."
        headerText="Comprar mi vehículo"
        headerSubText="Comprá tu chuzo de manera fácil y segura…"
        bottomBorder
      />
      <div className="purchase__content purchase__content--processing classic-form">
        <div class="animation">
            <div class="wrapper">
                <div class="container">
                    <div class="animated-circle small-circle"></div>
                    <div class="animated-circle small-circle2"></div>
                    <div class="animated-circle inner-circle"></div>
                    <div class="animated-circle inner-circle2"></div>
                    <div class="animated-circle outer-circle"></div>
                    <div class="animated-circle outer-circle2"></div>
                    <div class="a_logo"></div>
                    <h1>Tu reserva está en proceso</h1>
                    <div class="a_reloj"></div>
                    <h2>Estas cada vez más cerca de tener tu chuzo!</h2>
                    <p>Estamos realizando la reserva, por favor espera y no cerres esta ventana hasta obtener la confirmación.</p>
                    <p><strong>Esto puede tardar algunos minutos.</strong></p>
                    <div class="bg_circle one"></div>
                    <div class="bg_circle two"></div>
                    <div class="bg_circle three"></div>
                    <div class="bg_circle four"></div>
                    <div class="bg_circle five"></div>
                    <div class="bg_circle six"></div>
                    <div class="bg_circle seven"></div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseProcessing;
